<template>
    <v-app style="max-width: 60rem; height: 700px">
        <v-carousel class="vuetify-style" show-arrows-on-hover hide-delimiters v-model="model" height="700px">
            <v-carousel-item v-for="color in colors" :key="color">
                <v-sheet>
                    <v-row align="center" justify="center" padding="1rem">
                        <slot></slot>
                    </v-row>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>
    </v-app>
</template>

<script>
export default {
    data: () => ({
        model: 1,
        colors: ['primary', 'secondary', 'yellow', 'darken-2', 'red', 'orange'],
    }),
}
</script>
